import React, { useRef } from "react";
import { ImageUploadDisplay } from "./";

export default function GalleryItem({ image }) {
  const photoImageRef = useRef();

  return (
    <>
      <ImageUploadDisplay image={image} ref={photoImageRef} />
    </>
  );
}
